module.exports = __webpack_public_path__ + "static/img/09ok.37801bbd.webp";